import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
    FormErrorClassDirective,
    FormErrorClassFromDirective,
} from "./form-error-class.directive";
import { FormErrorsComponent } from "./form-errors.component";

const DECLARATIONS = [
    FormErrorClassDirective,
    FormErrorClassFromDirective,
    FormErrorsComponent,
];

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [...DECLARATIONS],
    exports: [...DECLARATIONS],
})
export class FormErrorsModule {}
